import { createApp } from 'vue'
import SquareRoot from './SquareRoot.vue'
import './assets/global.css'

createApp(SquareRoot).mount('#square-root')
